import React = require('react');
import { useState } from 'react';

export const EnhancedTripDisruptionMoreInfo = ({ infoText }) => {

  const [showMoreInfo, setShowMoreInfo] = useState(false);

  const changeShowMoreInfo = () => {
    setShowMoreInfo(!showMoreInfo)
  }

  return (
    <>
      <div>
        <span className={'more-info'}
              onClick={changeShowMoreInfo}>{showMoreInfo ? ' Less information' : ' More information'}
        </span>
      </div>
      {showMoreInfo && (
        <>
          <div>{infoText}</div>
          <div style={{marginTop: '20px'}}><b>Please note</b> – The enhanced trip disruption cover does not cover mid-trip connections or unused
            accommodation for delays of less than 24 hours
          </div>
        </>

      )}
    </>
  )
}
